import { render } from "./searchBox.vue?vue&type=template&id=4f0b5688&scoped=true"
import script from "./searchBox.vue?vue&type=script&lang=js"
export * from "./searchBox.vue?vue&type=script&lang=js"

import "./searchBox.vue?vue&type=style&index=0&id=4f0b5688&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0b5688"]])

export default __exports__